import React from 'react'
import PropTypes from 'prop-types'

const backgroundColor = (width) => {
	if(width > 66) {
		return '#4EB752'
	} else if (width > 33) {
		return '#eaca4a'
	} else {
		return '#F66455'
	}
}

const widthPercent = (score, maxScore) => {
	const percent = Math.round((Math.round(score) / maxScore)*100)
	if(percent < 5) {
		return 5
	}
	return percent
}

export default function PerformanceItem(props) {
	let { showPerformanceModal, score, maxScore, title, children } = props
	const width = widthPercent(score, maxScore)
	return (
		<div className="performance-item">
			<div className={`score-bar ${score}`}>
				<div className="score-indicator" style={{width: `${width}%`, backgroundColor: backgroundColor(width)}}></div>
				<p><span>{Math.round(score)}</span>/<span>{maxScore}</span></p>
			</div>
			<div className="score-detail-wrap">
				<h3>{title}</h3>
				{children}
				<a onClick={showPerformanceModal}>Read More</a>
			</div>
		</div>
	)
}

PerformanceItem.propTypes = {
	title: PropTypes.string,
	score: PropTypes.number,
	maxScore: PropTypes.number,
	showPerformanceModal: PropTypes.func,
	children: PropTypes.element.isRequired
}



// WEBPACK FOOTER //
// ./src/containers/ReportLoader/components/PerformanceItem.js